import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { debounceTime, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { DialogDirective } from 'src/shared-app-portal/components/dialog/dialog.directive';
import { CredentialSingletonService } from 'src/app/shared/services/credential-singleton.service';
import { PersonAutocompleteService } from './person-autocomplete.service';
import { AutoCompletePersonModel } from '../../models/autoCompletePerson';
import { TeamManagersModel } from 'src/app/teams/team-managers/team-managers.model';
import { TeamManagerService } from '../../services/team-manager.service';

@Component({
  selector: 'app-person-autocomplete',
  templateUrl: './person-autocomplete.component.html',
  styleUrls: ['./person-autocomplete.component.scss'],
  standalone: false
})
export class PersonAutoCompleteComponent implements OnInit {
  @ViewChild(DialogDirective, { static: true }) personDialogModal: DialogDirective;
  @Input({ required: true }) yesText: string;
  @Input({ required: true }) headerText: string;
  @Input({ required: true }) dialogType: DialogType;
  formControl = new FormControl();
  profiles: AutoCompletePersonModel[] = [];
  isLoading = false;
  selectedProfile: AutoCompletePersonModel | null = null;
  constructor(
    private personAutoCompleteService: PersonAutocompleteService,
    private teamManagerService: TeamManagerService,
    private credentialSingletonService: CredentialSingletonService
  ) {}

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        filter((value) => typeof value === 'string'),
        debounceTime(50),
        tap(() => {
          this.profiles = [];
          this.isLoading = true;
        }),
        switchMap((value) =>
          this.personAutoCompleteService.search(value).pipe(
            finalize(() => {
              this.isLoading = false;
            })
          )
        )
      )
      .subscribe((data: AutoCompletePersonModel[]) => {
        if (data) {
          this.profiles = data;
        }
      });
  }

  onSelected = (event: MatAutocompleteSelectedEvent) => {
    this.selectedProfile = event.option.value;
  };

  displayWith = (value: any) => {
    return value?.fullName;
  };

  clearSelection = () => {
    this.selectedProfile = null;
    this.profiles = [];
    this.formControl.reset();
  };

  openAddEntityDialog() {
    this.clearSelection();
    this.personDialogModal.open({
      onOkay: async () => {
        if (!this.selectedProfile) {
          return true;
        }

        if (this.dialogType === 'AddPointOfContact') {
          const result = await this.credentialSingletonService.addPointOfContact({
            personContactId: this.selectedProfile.id
          });
          return !!result;
        }
        if (this.dialogType === 'AddTeamManager') {
          const result = await this.teamManagerService.addTeamManager(
            this.credentialSingletonService.getEntityId,
            this.selectedProfile.id
          );
          return !!result;
        }
        throw new Error(`Unsupported dialog type: ${this.dialogType}`);
      }
    });
  }
}
type DialogType = 'AddTeamManager' | 'AddPointOfContact';
